import { Form } from 'antd';
import React, { useCallback, useEffect } from 'react';
import DollarX4InputNumber from '@aims/shared/components/DollarX4InputNumber';
import TaskSomethingForm from '../../tasks/ViewTaskModal/TaskSomethingForm';

function HProjectChangeLoanTotalInner({
  holisticProject,
  saving,
  handleFinish,
  onCancel,
  title = 'Change Loan Total',
}) {
  const [form] = Form.useForm();
  useEffect(() => {
    if (holisticProject) {
      form.setFieldsValue({
        loanTotalX4: holisticProject.loanTotalX4,
      });
    }
  }, [holisticProject, form]);
  const _handleFinish = useCallback(
    (_values) => {
      const { loanTotalX4, ...values } = _values;
      handleFinish({
        loanTotalX4,
        ...values,
      });
    },
    [handleFinish],
  );
  return (
    <TaskSomethingForm
      title={title}
      form={form}
      onFinish={_handleFinish}
      onCancel={onCancel}
      saving={saving}
    >
      <Form.Item
        label="Loan Total (USD)"
        name="loanTotalX4"
        initialValue={0}
        rules={[{ required: true, message: 'This field is required' }]}
        style={{ width: 200 }}
      >
        <DollarX4InputNumber disabled={saving} />
      </Form.Item>
    </TaskSomethingForm>
  );
}

export default HProjectChangeLoanTotalInner;
